import IncreaseAmountButton from './IncreaseAmountButton';

export default IncreaseAmountButton;
